// "Production" enabled environment
export const environment = {
    production: true,
    hmr: false,
    api_url: "https://azapp-legacy-api-hml.azurewebsites.net",
    medication_catalog_api_url: "https://azapp-medication-api-hml-fterhth9euf3hzbh.westus2-01.azurewebsites.net",
    instrumentationKey: "71582a85-f3de-426b-a10a-21fff8728d47",
    vforms_url: "https://kind-grass-08489601e.3.azurestaticapps.net",
    financial_api_url: "https://azapp-financial-api-hml.azurewebsites.net",
    webhooks_api_url: "https://azapp-webhooks-api-hml.azurewebsites.net",
    supportChatEnabled: true,
    posthogKey: "phc_xUDSAzU7Q59ur5m2VpeibVih5FzsYULMtZmMGe25Seai",
    posthogHost: "https://us.i.posthog.com/",
    gtmId: "GTM-K4LHFP5",
    heatmapKey: "",
    z_url: 'https://api.zoop.ws',
    z_marketplace: '468fc07005f745f2a1fb6b61e1bf64e0',
    z_key: 'zpk_test_GrQxKKmJEpgAMRuPz7kOOL5O',
    blob_url: 'https://stvsaudehml001.blob.core.windows.net',
    statistics_api_url: "",
    loadStorybook: "true",
    subscription_api_url: "https://azapp-subscription-api-hml.azurewebsites.net",
    pjbank_api_url: 'https://api.pjbank.com.br',
    pjbank_id: '176c095a50f7465d6484875db2b3a2d160ebb090',
    vindi_api_url: 'https://sandbox-app.vindi.com.br/api/v1/public',
    vindi_public_token: 'O9Y2dQRhWXGJ6jos1D-6hNXXoU5bWs0hlEpnaCyw-NQ',
};